<template>
  <b-modal
    v-model="showDialog"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    no-stacking
    class="p-4"
  >
    <b-row class="mb-4" align-h="between">
      <b-col class="text-right">
        <a href="javascript:;" @click="showDialog = false">
          <b-icon
            icon="x-circle-fill"
            variant="primary"
            font-scale="1"
          ></b-icon>
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <h4 class="heading">Download NDC Form</h4>
      </b-col>
      <b-col>
        <p v-if="rowData">for {{ rowData.firstname }} {{ rowData.lastname }}</p>
        <b-form-select
          v-model="selectedYear"
          :options="yearOptions"
          class="mb-3"
        ></b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="9" offset="3">
        <b-button
          variant="primary"
          block
          @click="download(rowData, selectedYear)"
          pill
          >Download NDC Form</b-button
        >
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="9" offset="3">
        <b-button
          variant="outline-primary"
          block
          @click="showDialog = false"
          pill
          >Cancel</b-button
        >
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { PatientService } from "@/services/patient.service";

export default {
  props: {
    rowData: {
      type: Object,
      default() {
        return {
          firstname: "",
          lastname: "",
        };
      },
    },
  },
  data() {
    return {
      showDialog: false,
      selectedYear: new Date().getFullYear(),
    };
  },
  computed: {
    yearOptions() {
      const currentYear = new Date().getFullYear();
      return this.range(2021, currentYear);
    },
  },
  methods: {
    range(start, end) {
      if (start === end) return [start];
      return [start, ...this.range(start + 1, end)];
    },
    async download(row, selectedYear) {
      try {
        const res = await PatientService.getNDCForm(row.id, selectedYear);
        let name = "";
        if (row.firstname) {
          name.concat(row.firstname);
        }
        if (row.firstname && row.lastname) {
          name.concat(" ");
        }
        if (row.lastname) {
          name.concat(row.lastname);
        }
        console.log(res);
        if (res.data) this.getFile(res.data, name);
      } catch (err) {
        // console.log(err.status);
        if (err.status == 404) {
          this.$emit(
            "show-toast",
            "There are no order receipts available for this year."
          );
        } else {
          this.$emit("show-toast", err.message);
        }
      }
    },
    getFile(url, name) {
      let link = document.createElement("a");
      link.href = url;
      let currentDate = new Date();
      if (name) name = " " + name;
      link.download = `NDC - ${currentDate}${name}`;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style></style>
